
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iI06X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $e8jdu = parcelRequire("e8jdu");


var $l6pMd = parcelRequire("l6pMd");


var $kDhla = parcelRequire("kDhla");





var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @generated SignedSource<<037b60172336b4b5b54329658095ab68>>
 * @relayHash e3915d12272b627d2618559a173ee623
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43b663d9649056a6c0dfa9fe437a3bf06ea1c47fa11d877c1439fabb16468bae
const $6738055776c0237a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentMode",
                            "variableName": "contentMode"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateContentModePayload",
            "kind": "LinkedField",
            "name": "confluence_updateContentMode",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentMode"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "commitUpdateContentModeMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "commitUpdateContentModeMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "e3915d12272b627d2618559a173ee623",
            "id": "43b663d9649056a6c0dfa9fe437a3bf06ea1c47fa11d877c1439fabb16468bae",
            "metadata": {},
            "name": "commitUpdateContentModeMutation",
            "operationKind": "mutation",
            "text": "mutation commitUpdateContentModeMutation($contentId:ID!,$contentMode:ConfluenceGraphQLContentMode!,$contentStatus:ConfluenceMutationContentStatus!,$cloudId:ID!){confluence_updateContentMode(cloudId:$cloudId,input:{contentId:$contentId,contentMode:$contentMode,contentStatus:$contentStatus}){contentId,contentMode,success,errors{message}}}"
        }
    };
}();
$6738055776c0237a$var$node.hash = "6aecb88002718fbacd480513a62a6ec2";
var $6738055776c0237a$export$2e2bcd8739ae039 = $6738055776c0237a$var$node;



var $6s78L = parcelRequire("6s78L");


var $86okN = parcelRequire("86okN");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $joyRP = parcelRequire("joyRP");


var $flWvL = parcelRequire("flWvL");

const $07e9e0d46d8428f8$var$CommitUpdateContentModeMutation = (0, $6738055776c0237a$export$2e2bcd8739ae039);
function $07e9e0d46d8428f8$var$writeModeToCache(opts) {
    const { contentId: contentId, isDraft: isDraft, uiMode: uiMode } = opts;
    const variables = {
        contentId: contentId,
        isDraft: isDraft,
        status: [
            isDraft ? 'draft' : 'current'
        ]
    };
    try {
        const prev = (0, $l1uFv.readQueryInterop)({
            query: (0, $joyRP.default),
            variables: variables
        });
        const node = prev?.content?.nodes?.[0];
        if (!node?.contentProperties) return;
        const nextNode = isDraft ? {
            ...node,
            contentProperties: {
                ...node.contentProperties,
                draft: {
                    ...node.contentProperties.draft ?? {},
                    contentMode: uiMode
                }
            }
        } : {
            ...node,
            contentProperties: {
                ...node.contentProperties,
                latest: {
                    ...node.contentProperties.latest ?? {},
                    contentMode: uiMode
                }
            }
        };
        const next = {
            ...prev,
            content: {
                ...prev.content,
                nodes: [
                    nextNode,
                    ...prev.content.nodes.slice(1) ?? []
                ]
            }
        };
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $joyRP.default),
            variables: variables,
            data: next
        });
    } catch  {
    // it's fine if the query result isn't in the cache yet
    }
}
async function $07e9e0d46d8428f8$export$60539da390c77305({ contentId: contentId, contentMode: contentMode, contentStatus: contentStatus, refetchContentId: refetchContentId, cloudId: cloudId }) {
    const isDraft = contentStatus === 'DRAFT';
    return (0, $6s78L.mutateInterop)({
        mutation: $07e9e0d46d8428f8$var$CommitUpdateContentModeMutation,
        variables: {
            contentId: contentId,
            contentMode: contentMode,
            contentStatus: contentStatus,
            cloudId: cloudId
        },
        // ensure the UI flips instantly even before the network returns
        optimisticResponse: {
            confluence_updateContentMode: {
                __typename: 'ConfluenceUpdateContentModePayload',
                contentId: contentId,
                contentMode: contentMode,
                success: true,
                errors: []
            }
        },
        update (_cache, { data: data }) {
            const payload = data?.confluence_updateContentMode;
            // if server explicitly marks failure, don't write success into cache
            if (payload && payload.success === false) return;
            const modeFromPayload = payload?.contentMode ?? contentMode;
            const ui = (0, $flWvL.serverToUiContentMode)(modeFromPayload);
            $07e9e0d46d8428f8$var$writeModeToCache({
                contentId: contentId,
                isDraft: isDraft,
                uiMode: ui
            });
        },
        // single refetch to reconcile server truth if requested
        refetchQueries: refetchContentId ? [
            {
                query: (0, $86okN.toDocumentNode)((0, $joyRP.default)),
                variables: {
                    contentId: refetchContentId,
                    isDraft: isDraft,
                    status: [
                        isDraft ? 'draft' : 'current'
                    ]
                }
            }
        ] : [],
        // allow UI continue since the optimistic update already applied immediately
        awaitRefetchQueries: false
    });
}






var $gGHFp = parcelRequire("gGHFp");

function $8cafb8c7b49631b1$export$1517f72952f2255f({ contentId: contentId }) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const contentStatus = (0, $flWvL.resolveContentStatus)({
        isLivePage: isLivePage,
        isEditorPage: isEditorPage
    });
    const { mode: mode = 'standard' } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    const toggle = (0, $42omo.useCallback)(async ()=>{
        if (isSaving) return {
            ok: false,
            from: mode,
            to: mode
        };
        const from = mode;
        const to = (0, $flWvL.flipContentMode)(from);
        setIsSaving(true);
        try {
            const res = await (0, $07e9e0d46d8428f8$export$60539da390c77305)({
                contentId: contentId,
                contentMode: (0, $flWvL.uiToServerContentMode)(to),
                contentStatus: contentStatus,
                refetchContentId: contentId,
                cloudId: cloudId
            });
            const payload = res?.data?.confluence_updateContentMode;
            const errorCount = payload?.errors?.length ?? 0;
            const ok = payload?.success !== false && errorCount <= 0;
            return {
                ok: Boolean(ok),
                from: from,
                to: to
            };
        } catch (err) {
            (0, $7Sm4c.markErrorAsHandled)(err);
            return {
                ok: false,
                from: from,
                to: to
            };
        } finally{
            setIsSaving(false);
        }
    }, [
        isSaving,
        mode,
        contentId,
        contentStatus,
        cloudId
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isSaving: isSaving,
            toggle: toggle
        }), [
        mode,
        isSaving,
        toggle
    ]);
}


const $04b10b6f477ede53$var$messages = (0, $cgtv4.defineMessages)({
    makeCompact: {
        id: "editor-content-mode-button.make.compact",
        defaultMessage: "Use compact density"
    },
    makeStandard: {
        id: "editor-content-mode-button.make.standard",
        defaultMessage: "Use standard density"
    }
});
const $04b10b6f477ede53$export$a8e3305d336ef5aa = ({ contentId: contentId, disabled: disabled = false, isStatusDisconnected: isStatusDisconnected = false })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const { mode: mode, isSaving: isSaving, toggle: toggle } = (0, $8cafb8c7b49631b1$export$1517f72952f2255f)({
        contentId: contentId
    });
    const isCompact = mode === 'compact';
    const label = intl.formatMessage(isCompact ? $04b10b6f477ede53$var$messages.makeStandard : $04b10b6f477ede53$var$messages.makeCompact);
    const Icon = (0, $42omo.useMemo)(()=>isCompact ? (0, (/*@__PURE__*/$parcel$interopDefault($l6pMd))) : (0, (/*@__PURE__*/$parcel$interopDefault($e8jdu))), [
        isCompact
    ]);
    const isBlocked = disabled || isStatusDisconnected || isSaving;
    const fireAnalytics = (0, $42omo.useCallback)((from, to)=>{
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: 'updateContentMode',
                actionSubject: 'updateContentMode',
                source: 'EditorContentModeButton',
                attributes: {
                    contentId: contentId,
                    previousMode: from,
                    mode: to
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const runEditorContentModeCommand = (0, $42omo.useCallback)((nextMode)=>{
        const command = fullPageEditorPresetAPI?.contentFormat?.commands?.updateContentMode?.(nextMode);
        if (!command) return;
        fullPageEditorPresetAPI?.core?.actions?.execute(command);
    }, [
        fullPageEditorPresetAPI
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (!contentId || isStatusDisconnected || isSaving) return;
        const { ok: ok, from: from, to: to } = await toggle();
        if (ok) {
            fireAnalytics(from, to);
            runEditorContentModeCommand(to);
        }
    }, [
        contentId,
        isStatusDisconnected,
        isSaving,
        toggle,
        fireAnalytics,
        runEditorContentModeCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "default",
        isDisabled: isBlocked || isSaving,
        onClick: handleClick,
        isTooltipDisabled: false,
        label: label,
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...props,
                label: label
            }),
        testId: "editor-content-mode-button"
    });
};
module.exports["EditorContentModeButton"] = $04b10b6f477ede53$export$a8e3305d336ef5aa;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("6s78L", function(module, exports) {

var $75HqD = parcelRequire("75HqD");


var $86okN = parcelRequire("86okN");

function $0b6144addfe7c9d4$export$7bf8518c2628f671(params) {
    return $0b6144addfe7c9d4$var$mutateInteropApollo(params);
}
const $0b6144addfe7c9d4$var$UNSUPPORTED_RELAY_OPTIONS = [
    'optimisticResponse',
    'update',
    'refetchQueries',
    'awaitRefetchQueries'
];
function $0b6144addfe7c9d4$var$mutateInteropRelay(params) {
    // Check for unsupported options
    const unsupportedOptions = Object.keys(params).filter((key)=>$0b6144addfe7c9d4$var$UNSUPPORTED_RELAY_OPTIONS.includes(key));
    if (unsupportedOptions.length > 0) throw new Error(`[Relay migration] ${unsupportedOptions} are not supported yet`);
    return (0, $75HqD.commitMutation)(window.GLOBAL_RELAY_ENV, {
        mutation: params.mutation,
        variables: params.variables ?? {}
    }).then((result)=>{
        return {
            data: result
        };
    }).catch((error)=>{
        if (params.errorPolicy === 'ignore' || params.errorPolicy === 'all') return {
            data: null,
            errors: error.graphQLErrors || [
                error
            ]
        };
        throw error;
    });
}
function $0b6144addfe7c9d4$var$mutateInteropApollo({ mutation: mutation, ...rest }) {
    return window['GLOBAL_APOLLO_CLIENT'].mutate({
        ...rest,
        mutation: (0, $86okN.toDocumentNode)(mutation)
    });
}
module.exports["mutateInterop"] = $0b6144addfe7c9d4$export$7bf8518c2628f671;

});

parcelRegister("75HqD", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $422HI = parcelRequire("422HI");

const $998dea875afc431e$export$e454457a489de4f6 = (relayEnvironment, mutation)=>new Promise((resolve, reject)=>{
        (0, $3e6Uc.commitMutation)(relayEnvironment, {
            ...mutation,
            onCompleted: (response, errors)=>{
                if (errors) reject(new (0, $422HI.ApolloErrorInterop)({
                    graphQLErrors: errors.map((error)=>({
                            ...error,
                            path: error.path?.map(String)
                        }))
                }));
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
module.exports["commitMutation"] = $998dea875afc431e$export$e454457a489de4f6;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true));
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("e8jdu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a4b28a13363cb05d76b308a3664c79d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4a0b80b80e864d4$var$_react = $a4a0b80b80e864d4$var$_interopRequireDefault((parcelRequire("42omo")));

var $a4a0b80b80e864d4$var$_baseNew = $a4a0b80b80e864d4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a4a0b80b80e864d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextDensityCompress".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for increasing the density of text by reducing font size and/or line height.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4a0b80b80e864d4$var$TextDensityCompressIcon = (props)=>/*#__PURE__*/ $a4a0b80b80e864d4$var$_react.default.createElement($a4a0b80b80e864d4$var$_baseNew.default, Object.assign({
        name: "TextDensityCompressIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.723 3a.75.75 0 0 1 .712.513L7.43 9.496l1.03 3.012a.8.8 0 0 1 .04.242V13H7v-.125l-.815-2.386H2.32l-.82 2.385V13H0v-.25l.01-.124a1 1 0 0 1 .031-.12l1.035-3.01 2.006-5.984.047-.11A.75.75 0 0 1 3.793 3zM13 3v5.44l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V3zM2.827 8.99H5.68L4.257 4.723z"/>`
    }, props));
$a4a0b80b80e864d4$var$TextDensityCompressIcon.displayName = 'TextDensityCompressIcon';
var $a4a0b80b80e864d4$var$_default = module.exports.default = $a4a0b80b80e864d4$var$TextDensityCompressIcon;

});

parcelRegister("l6pMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4cd66c1e1ec67792dace27b5ca8f11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5ce273601e5ce09$var$_react = $f5ce273601e5ce09$var$_interopRequireDefault((parcelRequire("42omo")));

var $f5ce273601e5ce09$var$_baseNew = $f5ce273601e5ce09$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f5ce273601e5ce09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextDensityExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for reducing the density of text by increasing font size and/or line height.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5ce273601e5ce09$var$TextDensityExpandIcon = (props)=>/*#__PURE__*/ $f5ce273601e5ce09$var$_react.default.createElement($f5ce273601e5ce09$var$_baseNew.default, Object.assign({
        name: "TextDensityExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.723 3a.75.75 0 0 1 .712.513L7.43 9.496l1.03 3.012a.8.8 0 0 1 .04.242V13H7v-.125l-.815-2.386H2.32l-.82 2.385V13H0v-.25l.01-.124a1 1 0 0 1 .031-.12l1.035-3.01 2.006-5.984A.75.75 0 0 1 3.793 3zm7.053.168a.75.75 0 0 1 1.004.052l3 3-1.06 1.06L13 5.56V11h-1.5V5.56L9.78 7.28 8.72 6.22l3-3zM2.827 8.99H5.68L4.257 4.724z"/>`
    }, props));
$f5ce273601e5ce09$var$TextDensityExpandIcon.displayName = 'TextDensityExpandIcon';
var $f5ce273601e5ce09$var$_default = module.exports.default = $f5ce273601e5ce09$var$TextDensityExpandIcon;

});


//# sourceMappingURL=EditorContentModeButton.e4ac8906.js.map
